export default "__VITE_ASSET__8fb8fa9d__"